import * as Constants from '../constants/Constants';
import * as utils from './utils';
import * as Helpers from './Helpers.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import '../components/Docking/Docking.css';

export function GeneratePDF(thisParam, ScreenType, language = "en") {

    let url = "";
    switch (ScreenType) {
        case "PORTFOLIO":
            url = Constants.GetExpectedPortfolioReport
            break;
        case "STATEMENT":
            url = Constants.GetAccountSummaryReport
            break;
        case "TRANSACTION":
            url = Constants.GetProfitLossTransactionReport
            break;
        case "TradesConfirmation":
            url = Constants.GetTradesConfirmationReport
            break;
        default:
            url = "";
            break;
    }
    // console.log("PDF_Url", url)

    if (url === null || url === "") {
        Helpers.errorNotify(thisParam.props.i18n.t("Something_went_Wrong,_please_try_again_later"), thisParam.props.i18n.language)
        return;
    }
    if (ScreenType === "TradesConfirmation") {
        // thisParam.props.ClientID  !== null         

        let reporturl = Constants.serverURL + "/reports.aspx?" +
            "type=pdf&reportName=" + ScreenType
            + "&mainClientIDF=" + thisParam.props.data.MainClientID
            + "&clientIDF=" + thisParam.props.data.ClientID
            + "&clientName=" + thisParam.props.data.MainIDDesc
            + "&webCode=" + localStorage.getItem("WebCode")
            + "&lang=" + (language === "en" ? "E" : "ar")
            // + "&dateFrom=" + Helpers.dateToString(new Date(), true)
            // + "&dateTo=" + Helpers.dateToString(new Date(), true)
            + "&dateFrom=" +  thisParam.props.data.TradeDate
            + "&dateTo=" +  thisParam.props.data.TradeDate
            + "&GroupType=" + "N"
            + "&CompID=" + "1"
            + "&BuySellFlag=" + thisParam.props.data.BuySellFlag
            + "&InvoiceSequence=" + thisParam.props.data.InvoiceSequence
            + "&companyName=" + localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase()
        // console.log("reporturl", reporturl)
        Helpers.getIsIPad() ? window.open(reporturl) : manageStatement(thisParam, reporturl);


    } else if (thisParam.state.selectedAccount !== null && thisParam.state.selectedAccount.ClientID !== undefined && thisParam.state.selectedAccount.ClientID !== "") {
        let compId = "";
        if (ScreenType === "TRANSACTION") {
            if (thisParam.state.selectedSymbol === null || thisParam.state.selectedSymbol === "") {
                Helpers.errorNotify(thisParam.props.i18n.t("Symbol_is_required"), thisParam.props.i18n.language)
                return;
            } else {
                compId = thisParam.props.symbols.filter((sym) => (sym.Symbol === thisParam.state.selectedSymbol))[0].SymbolID
            }
        }
        var d = new Date();
        d.setMonth(d.getMonth() - 1);
        let DateFrom = ScreenType === "PORTFOLIO" ? Helpers.dateToString(new Date(), true)
            : ScreenType === "STATEMENT" ? Helpers.dateToString(thisParam.state.fromDate, true) : thisParam.state.firstDateRecord;
        let DateTo = ScreenType === "PORTFOLIO" ? Helpers.dateToString(new Date(), true)
            : ScreenType === "STATEMENT" ? Helpers.dateToString(thisParam.state.toDate, true) : Helpers.dateToString(new Date(), true);

        let reporturl = Constants.serverURL + "/reports.aspx?" +
            "type=pdf&reportName=" + ScreenType
            + "&MainClientID=" + thisParam.state.selectedAccount.MainClientID
            + "&ClientID=" + thisParam.state.selectedAccount.ClientID
            + "&ClientNameE=" + thisParam.state.selectedAccount.MainClientNameE
            + "&ClientNameA=" + thisParam.state.selectedAccount.MainClientNameA
            + "&AccountNameE=" + thisParam.state.selectedAccount.ClientNameE
            + "&AccountNameA=" + thisParam.state.selectedAccount.ClientNameA
            + "&WebCode=" + localStorage.getItem("WebCode")
            + "&SysLang=" + (language === "en" ? "E" : "A")
            + "&DateFrom=" + DateFrom
            + "&DateTo=" + DateTo
            + "&GroupType=" + (ScreenType === "STATEMENT" ? (
                thisParam.state.selectedOption === "1" ? "O"
                    : thisParam.state.selectedOption === "2" ? "C"
                        : "N") : "N")
            + "&CompID=" + (ScreenType === "TRANSACTION" ? compId : "1")
        // console.log("reporturl", reporturl)
        Helpers.getIsIPad() ? window.open(reporturl) : manageStatement(thisParam, reporturl);
        // let param = {
        //     "MainClientID": thisParam.state.selectedAccount.MainClientID,
        //     "ClientID": thisParam.state.selectedAccount.ClientID,
        //     "DateFrom": DateFrom,
        //     "DateTo": DateTo,
        //     "SysLang": language === "en" ? "E" : "A",
        //     "WebCode": localStorage.getItem("WebCode"),
        //     "DNum": "0",
        //     "ReportingSymbolE": "",
        //     "ReportingSymbolA": "",
        //     "AccountNameE": thisParam.state.selectedAccount.ClientNameE,
        //     "AccountNameA": thisParam.state.selectedAccount.ClientNameA,
        //     "ClientNameE": thisParam.state.selectedAccount.MainClientNameE,
        //     "ClientNameA": thisParam.state.selectedAccount.MainClientNameA,
        //     "CompID": compId,
        //     "isDvp": "",
        //     "isTax": "",
        //     "GroupType": ScreenType === "STATEMENT" ? (
        //         thisParam.state.selectedOption === "1" ? "O"
        //             : thisParam.state.selectedOption === "2" ? "C"
        //                 : "N") : "",
        //     "MarginEval": ""
        // }
        // let responses = utils.GenerateReports(url, param);
        // responses.then(response => response.data)
        //     .then(data => {
        //         
        //         // var file = new Blob([data], { type: 'application/pdf' });
        //         // var fileURL = URL.createObjectURL(file);
        //         // window.open(fileURL);
        //         if (data !== null) {
        //             var file = new Blob([data], { type: 'application/pdf' });
        //             var fileURL = URL.createObjectURL(file);
        //             window.open(fileURL);
        //         }
        //         else {
        //             thisParam.errorNotify("nothing to show")
        //             return;
        //         }
        //     }).catch((error) => {
        //         console.log("GeneratePDF", error);
        //     })

    }
    else {
        Helpers.errorNotify(thisParam.props.i18n.t("Something_went_Wrong,_please_try_again_later"), thisParam.props.i18n.language)
        return;
    }
}

function manageStatement(thisParam, link) {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <div className={'custom-popup custom-scrollable  PDF-REport   ' + Helpers.getAppTheme() + localStorage.getItem(Constants.localStorageConstants.company_name) + "-CSS"}>

                    <div className='custom-popup-header pt-2  PopupHeaderTitle'
                        style={{ display: "flex", flexDirection: thisParam.props.i18n.language === "ar" ? "row-reverse" : "unset" }}>
                        <div className={thisParam.ml3LocalizedPopupHeader + " " + thisParam.mrAutoLocalized} style={{ fontSize: "14px" }}>
                            <strong className="lableCustomized">PDF Report</strong>
                        </div>
                        <div className={thisParam.mr3LocalizedPopupHeader + " " + thisParam.mlAutoLocalized}>
                            <span
                                className="my-panel-extra-btn"
                                style={{
                                    marginLeft: "unset",
                                    float: "right",
                                    transition: "none",
                                    color: "white",
                                    opacity: "1",
                                    contain: "content",
                                    width: "unset",
                                    marginRight: "unset"
                                }}
                                onClick={onClose}>X</span>
                        </div>
                    </div>
                    <div
                        className="custom-popup-body pt-2 pb-2 display-vertically"
                        style={{ height: "calc(100% - 45px)", overflowY: "auto", direction: thisParam.dir }} >
                        <iframe
                            key={Math.random()}
                            src={link}
                            style={{ width: "100%", height: "100%" }}
                        >
                        </iframe>
                    </div>
                </div >
            );
        }
    });
};
